module.exports = __webpack_public_path__ + "static/media/truck-moving.744fbce1.svg";